import GuidesHero from "./components/hero/index.vue";
import GuidesTextBlock from "./components/text-block/index.vue";
import GuidesTrendBook from "./components/trendbook/index.vue";
import GuidesList from "./components/list/index.vue";
import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "@/helpers/variables";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
    name: "GuidesPage",
    props: {},
    emits: [],
    mixins: [dynamicsHead],
    components: { GuidesList, GuidesTrendBook, GuidesTextBlock, GuidesHero },
    async created() {
        globalLoader(true)
        await this.fetchGuidesPage();
        globalLoader(false)
        this.setPageMetaInfo(this.content)
    },
    watch: {},
    computed: {
      ...mapGetters({
        content: "guides/content",
      })
    },
    methods: {
        ...mapActions({
            fetchGuidesPage: "guides/FETCH_GUIDES_PAGE",
        })
    }
}
